import React from 'react';
import './App.css';

class App extends React.Component {
	render() {
		const { main, search } = this.props
        return (
          <div>
              <div className="Main">
                  {main}
              </div>
              <div className="Search">
                  {search}
              </div>
          </div>
        );
	}
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/modules/App.js
 **/